import { SITE_ORIGIN, articleUrl } from './articleUrl'

function setMeta(attribute, name, content) {
  let element = document.head.querySelector(`meta[${attribute}="${name}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, name)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content || '')
}

export function setCanonical(url) {
  document.head.querySelectorAll('link[rel="canonical"]').forEach(element => element.remove())
  if (!url) return
  const element = document.createElement('link')
  element.rel = 'canonical'
  element.href = url
  document.head.appendChild(element)
}

export function resetPageHead(route) {
  document.title = route.meta.title || 'NAVLIN DAILY'
  setCanonical(route.name === 'landing' ? SITE_ORIGIN + '/' : '')
  document.head.querySelectorAll('meta[name="description"], meta[data-article-error]').forEach(element => element.remove())
  setMeta('property', 'og:title', document.title)
  for (const name of ['og:description', 'og:image', 'og:url']) setMeta('property', name, '')
}

export function setArticleHead(article, description) {
  document.title = article.headline + ' | NAVLIN DAILY'
  setCanonical(articleUrl(article))
  setMeta('name', 'description', description)
  setMeta('property', 'og:title', article.headline)
  setMeta('property', 'og:description', description)
  setMeta('property', 'og:image', article.image)
  setMeta('property', 'og:url', articleUrl(article))
}

export function markArticleNotFound() {
  setMeta('name', 'robots', 'noindex')
  document.head.querySelector('meta[name="robots"]').setAttribute('data-article-error', '')
}
